import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '@lib/permissions/guards'
import { InventaireView } from '@features/stock/components/InventaireView'

export const Route = createFileRoute('/_app/stock/inventaires/$id/view')({
  loader: requirePermission('stock.inventaires.view'),
  component: InventaireViewWrapper,
})

function InventaireViewWrapper() {
  const { id } = Route.useParams()
  return <InventaireView id={Number(id)} />
}
